import { stickyForm } from './components/sticky-form/sticky-form';

stickyForm.init();
